import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const wsBase = () => {
  const url = BACKEND_URL || window.location.origin;
  return url.replace(/^http/, "ws") + "/api";
};

export const createRoom = async ({ p1_name, difficulty }) => {
  const res = await axios.post(`${API}/rooms`, { p1_name, difficulty });
  return res.data;
};

export const getRoom = async (code) => {
  const res = await axios.get(`${API}/rooms/${encodeURIComponent(code)}`);
  return res.data;
};
